<template>
  <main class="fixed_adjustment">
    <section>
      <div class="main_visual noodles_main_bg">
        <div class="main_pos">
          <p class="main_img">
            <img
              src="@/assets/img/page/noodles_main.png"
              alt="天下一品グッズ通販オリジナル商品"
              width="100%"
              height="auto"
            />
          </p>
          <div class="main_txt_area">
            <p class="main_txt">
              <span class="c_red01">家</span>で作る！<span class="c_red01"
                >家</span
              >で食べる！
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="inner01">
      <div class="bg_yellow">
        <div class="inner">
          <div class="urgency_list">
            <p class="text-align_c">
              災害時の配送などについての緊急性の高いお知らせを掲載します。災害時の配送などについての緊急性の高いお知らせを掲載します。<br />
              災害時の配送などについての緊急性の高いお知らせを掲載します。
            </p>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="section_box bg_brown">
        <div class="inner">
          <h2 class="tit_style02">新商品</h2>
        </div>
      </div>
      <div class="inner">
        <ul v-if="newProduct" class="three_column minusmgt35 new_list">
          <li v-for="item in newProduct.slice(0, 3)" :key="item.id">
            <a
              v-if="item.product_categories && item.product_categories.length"
              href="javascript:void(0)"
              @click="
                toCategory(item.product_categories[0].category_id, item.id)
              "
            >
              <div class="three_column_img_area">
                <img :src="item.main_image" alt="ダミー" />
              </div>
              <div class="three_column_tit_area">
                <h3 class="tit_style03">
                  <span class="sub_tit01">{{ item.name }}</span>
                </h3>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </section>
    <section class="section_box">
      <div class="inner">
        <ul class="taset_list">
          <li v-for="item in categoryList" :key="item.category_id">
            <div class="taset_img">
              <img src="@/assets/img/page/rich.jpg" :alt="item.name" />
            </div>
            <div class="taste_txt_area bg02">
              <h2 class="tit_style02 mgb35">{{ item.category_name }}</h2>
              <p class="teste_txt t_center">
                4食セットと6食セットから<br />お選びいただけます。
              </p>
              <p class="btn_size08 btn_style06 mg0">
                <router-link
                  class="choice_bg01"
                  exact
                  :to="{
                    name: 'noodlesDetail',
                    params: { id: item.category_id }
                  }"
                  >商品詳細</router-link
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="section_box01">
      <h2 class="tit_style02 mgb40">はじめてご利用の方へ</h2>
      <div class="inner">
        <ul class="two_column mgb40">
          <li class="bg03">
            <router-link to="/guide" class="guide_box">
              <div class="guide_box_center">
                <h3 class="tit_style04">お買い物ガイド</h3>
              </div>
            </router-link>
          </li>
          <li class="bg04">
            <router-link to="/faq" class="guide_box">
              <div class="guide_box_center">
                <h3 class="tit_style04">よくあるご質問</h3>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CATEGORY_LIST, GET_NEW_PRODUCT } from "@/store/actions.type";
export default {
  name: "VNoodles",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["categoryList", "newProduct"])
  },
  created() {
    this.$store.dispatch(GET_CATEGORY_LIST, {
      limit: 10,
      offset: 0,
      name: "ラーメン"
    });
    this.$store.dispatch(GET_NEW_PRODUCT);
  },
  methods: {
    toCategory(category_id, product_id) {
      this.$router.push({
        name: "noodlesDetail",
        params: { id: category_id },
        query: { product_id: product_id }
      });
    }
  }
};
</script>

<style></style>
